
export type IPublicTypeEditorValueKey = (new (...args: any[]) => any) | symbol | string;
